import React, { Component } from "react";
import { sendContacts } from "../../tools/sendContacts";
import Modal from "react-bootstrap/Modal";

const initData = (lang) => (lang === "en" ? en : ru);

const getDate = (lang, page) => {
  if (lang === "ru" && page === "general") {
    return desc.ru;
  } else if (lang === "en" && page === "general") {
    return desc.en;
  } else if (lang === "ru" && page === "restaurant") {
    return desc.ruRestaurant;
  } else if (lang === "en" && page === "restaurant") {
    return desc.enRestaurant;
  } else if (lang === "ru" && page === "health") {
    return desc.ruHealth;
  } else if (lang === "en" && page === "health") {
    return desc.enHealth;
  } else if (lang === "ru" && page === "communal") {
    return desc.ruСommunal;
  } else if (lang === "en" && page === "communal") {
    return desc.enСommunal;
  } else if (lang === "ru" && page === "portfolio") {
    return desc.ru;
  }
};
const desc = {
  en: {
    title: "Mobile development for business",
  },
  ru: {
    title: "Разработка мобильных приложений",
    titleSmall: "",
  },
  enHealth: {
    title: "Mobile app Development ",
    titleSmall: "in the field of “health and fitness”",
  },
  ruHealth: {
    title: "Разработка мобильных приложений",
    titleSmall: " в сфере “здоровье и фитнес”",
  },
  enRestaurant: {
    title: "Mobile and web app Development ",
    titleSmall: "for restaurants, cafes, bars",
  },
  ruRestaurant: {
    title: "Разработка мобильных и веб приложений ",
    titleSmall: "для ресторанов, кафе, баров",
  },
  enСommunal: {
    title: "Mobile app Development ",
    titleSmall: "for housing & public utilities and management companies",
  },
  ruСommunal: {
    title: "Разработка мобильных приложений",
    titleSmall: "для ЖКХ и управляющих компаний",
  },
};
const en = {
  // heading: "Mobile app Development ",
  invitation: "Want to learn more about us? Download our Presentation!",
  liOne: "Pay-for-performance",
  liTwo: "Quick launch",
  liThree: "Dedicated team for the project",
  btnText: "Get a presentation",
  heroThumb: "/img/features_thumb.png",
  formHeader: "Fill out an application",
  formButton: "Send message",
  name: "Name*",
  tel: "Phone",
  email: "E-mail*",
  text: "Subscribe to our social networks",
  sendText: "We have received your message",
  sendError: "An error has occurred! Try later.",
  pot: "surname",
  errorName: "Name must not contain numbers",
  errorPhone: "The phone number was entered incorrectly",
  errorEmail: "The email field contains errors",
  necessarily: "Please fill in this field",
  tags: [
    {
      text: "#Фудтех",
      img: "/img/Foodtech.svg",
    },
    {
      text: "#Стартапы",
      img: "/img/start-up.svg",
    },
    {
      text: "#Финтех",
      img: "/img/Fintech.svg",
    },
    {
      text: "#Рестораны ",
      img: "/img/Fintech.svg",
    },
  ],
  tagsTwo: [
    {
      text: "LifeStyle",
      img: "/img/life-style.svg",
    },
    {
      text: "B2B",
      img: "/img/b2b.svg",
    },

    {
      text: "Разработка сайтов",
      img: "/img/Website.svg",
    },

    {
      text: "ЖКХ",
      img: "/img/jkh.svg",
    },
    {
      text: "Мобильная разработка",
      img: "/img/mobile-design.svg",
    },

    {
      text: "Utilities",
      img: "/img/Utilities.svg",
    },
  ],
};

const ru = {
  // heading: "Разработка мобильных приложений",
  liOne: "оплата за результат",
  liTwo: "быстрый запуск",
  liThree: "выделенная команда под проект",
  invitation: "Чтобы узнать о нас больше, скачайте презентацию о компании",
  btnText: "Получить презентацию",
  formHeader: "Заполнить заявку",
  formButton: "Отправить",
  name: "Имя*",
  tel: "Телефон",
  email: "Эл. адрес*",
  text: "Подписывайтесь на наши соц. сети",
  sendText: "Ваша заявка принята",
  sendError: "Произошла ошибка! Попробуйте позже.",
  pot: "фамилия",
  errorName: "Имя не должно содержать цифр",
  errorPhone: "Номер телефона введен не верно",
  errorEmail: "поле email содержит ошибки",
  necessarily: "Заполните это поле",

  tags: [
    {
      text: "#Стартапы",
      img: "/img/start-up.svg",
    },
    {
      text: "#Финтех",
      img: "/img/Fintech.svg",
    },
    {
      text: "#Рестораны",
      img: "/img/Foodtech.svg",
    },
    {
      text: "LifeStyle",
      img: "/img/life-style.svg",
    },
  ],
  tagsTwo: [
    {
      text: "B2B",
      img: "/img/b2b.svg",
    },

    {
      text: "Разработка сайтов",
      img: "/img/Website.svg",
    },

    {
      text: "ЖКХ",
      img: "/img/jkh.svg",
    },
    {
      text: "Мобильная разработка",
      img: "/img/mobile-design.svg",
    },

    {
      text: "Utilities",
      img: "/img/Utilities.svg",
    },
  ],
};

class TagRedBlock extends Component {
  state = {
    data: {},
  };

  componentDidMount() {
    this.setState({
      data: initData(this.props.lang),
      dataHead: getDate(this.props.lang, this.props.page),
    });
  }

  render() {
    return (
      <div
        onClick={this.props.onClick}
        className={`mt-2 item-tag ${this.props.class}`}
      >
        <div>{this.props.tag.name}</div>
      </div>
    );
  }
}

export default TagRedBlock;
